// src/components/KeyIndicatorsDashboard.js
import React, { useMemo } from 'react';
import { Box, Typography, Paper, Stack, Divider, useTheme, Tooltip } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VitalsSparkline from './VitalsSparkline';

export default function KeyIndicatorsDashboard({ checkIns, onOpenModal }) {
    const theme = useTheme();
    // Define the specific check-ins we want to elevate
    const KEY_INDICATOR_TITLES = ['shortness of breath', 'bowel movement'];
    const INDICATOR_METADATA = {
        'shortness of breath': { color: theme.palette.info.main, title: 'Shortness of Breath' },
        'bowel movement': { color: theme.palette.warning.dark, title: 'Bowel Movements' },
    };

    // Filter the check-ins to find our key indicators
    const keyIndicators = useMemo(() => {
        if (!checkIns) return [];
        return checkIns.filter(ci => 
            KEY_INDICATOR_TITLES.some(keyword => 
                ci.content_item?.title.toLowerCase().includes(keyword)
            )
        );
    }, [checkIns]);

    if (keyIndicators.length === 0) return null; // Don't render if no key indicators are found

    return (
        <Paper elevation={2} sx={{ p: { xs: 1.5, md: 2 }, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <TrendingUpIcon sx={{ mr: 1, color: 'text.secondary' }} /> Key Indicators
            </Typography>
            <Stack divider={<Divider />} spacing={1}>
                {keyIndicators.map(indicator => {
                    const metadataKey = KEY_INDICATOR_TITLES.find(k => indicator.content_item.title.toLowerCase().includes(k));
                    const metadata = INDICATOR_METADATA[metadataKey] || {};
                    const seriesData = indicator.series || [];

                    return (
                        <Tooltip key={indicator.id} title="Double-click for details">
                            <Box
                                onDoubleClick={() => onOpenModal(indicator, indicator)}
                                sx={{ p: 1, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' }, borderRadius: 1 }}
                            >
                                <VitalsSparkline
                                    data={seriesData}
                                    title={metadata.title || indicator.content_item.title}
                                    color={metadata.color || theme.palette.grey[500]}
                                />
                            </Box>
                        </Tooltip>
                    );
                })}
            </Stack>
        </Paper>
    );
}